import http from './http-util'
import config from '../../../config'

class AuditServiceApi {
  static getHistory =
    ({ page, size, filter }) =>
    token =>
      http.post(
        token,
        `${config.auditServiceUrl}/find?page=${page}&size=${size}`,
        JSON.stringify(filter),
      )
}

export const TypeFilters = {
  USER_SERVICE: {
    'user-service': ['User', 'Username'],
  },
  CONFIGURATION_SERVICE: {
    'configuration-service': [
      'Logotype',
      'PaymentMethod',
      'Representative',
      'Store',
      'Credentials',
      'CheckoutSettings',
      'InvoiceSettings',
      'PaymentSettings',
    ],
  },
}

export default AuditServiceApi
